import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";


export const LayoutMaster = "webapp-type2";


export const GLOBAL_IV = "a7eda6dc9e3305b593a98ab7947cd254"
//CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
export const GLOBAL_SALT = "2e6d3cbbc2f0351fcca7172e43cf918c"
//CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);

export const GOOGLE_CAPTCHA_KEY="6LeY6xIqAAAAAEeXCkFlq0dcUJxZVKitcl06Nzx-";


export const LANDSCAPE = 'landscape';
export const PORTRAIT = 'portrait';


// GA Events
export const LAUNCHED = "LAUNCHED"
export const CLICKED = "CLICKED"
export const EXIT = "EXIT"
export const DURATION = "DURATION"

export const MOBILE_CHECKIN_CATEGORY = "Mobile_Check_in"
export const DOOR_KEY_CATEGORY = "Digital Door Key"

export const DINING_RESERVATION_CATEGORY = "DINING_RESERVATION"
export const SPA_BOOKING_CATEGORY = "SPA_BOOKING"
export const TABLE_RESERVATION_CATEGORY = "Table_Reservation"

export const URL_RENDERER_CATEGORY = "URL_RENDERER"
export const URL_IFRAME_RENDERER_CATEGORY = "URL_IFRAME_RENDERER"

export const MY_BILL_CATEGORY = "MY_BILL"

export const GUEST_REQUEST_CATEGORY = "GUESTREQUEST"

export const HCOMMERCE = "Hcommerce"
export const WAY_ACTIVITIES = "WAY_ACTIVITIES";

export const ENABLE_SOFT_PHONE = process.env.REACT_APP_ENABLE_SOFT_PHONE == "true";


export const REALTIMEBOOKING = "RealtimeBooking"


export const LARGE = "LARGE";
export const SMALL = "SMALL";

export const CRASHLYTICSCOLLECTION = true;

export const protocol = process.env.REACT_APP_API_PROTOCOL;
console.log('protocol',protocol);

export const marketSegment = process.env.REACT_APP_MARKET_SEGMENT;

export const masterIP = process.env.REACT_APP_SERVER_IP;
export let currentIP;

export const master_client_config = process.env.REACT_APP_CLIENT_CONFIG;
export let current_client_config;

export const CMSPath_Master =  masterIP.startsWith("http") ? `${masterIP}` : protocol == 'http' ? `http://${masterIP}:8080` : `https://${masterIP}:8443`;
export let CMSPath;
export let CMSPath_HTTP;

export let clientConfigPath;
export let clientConfigPathMaster;
export let activityPath;
export let roomControlPath;
export let clientConfigPosBaseEndPoint

export let IS_CHILD_CONNECTOR=false;

export const getAppConfig = async (props) => {
    const storedIP = await AsyncStorage.getItem("connectorIP");
    const storedIP_inroomapp = await AsyncStorage.getItem("connectorIP_inroomapp");
    currentIP = props.ConnectorIP || storedIP || storedIP_inroomapp || process.env.REACT_APP_SERVER_IP;

    const storedClientConfig = await AsyncStorage.getItem("clientId");
    const storedClientConfig_inroomapp = await AsyncStorage.getItem("clientId_inroomapp");
    current_client_config = props.clientId || storedClientConfig || storedClientConfig_inroomapp || process.env.REACT_APP_CLIENT_CONFIG;

    CMSPath = currentIP.startsWith("http") ? `${currentIP}` : protocol == 'http' ? `http://${currentIP}:8080` : `https://${currentIP}:8443`;

    CMSPath_HTTP = currentIP.startsWith("http") ? currentIP.replace("https", "http") : `http://${currentIP}:8080`;

    clientConfigPath = axios.create({
        baseURL: currentIP.startsWith("http")
          ? `${currentIP}/Connector/rest`
          : protocol == 'http' ? `http://${currentIP}:8080/Connector/rest` : `https://${currentIP}:8443/Connector/rest`,
          timeout: 20000,
      })

      clientConfigPathMaster = axios.create({
        baseURL: masterIP.startsWith("http")
          ? `${masterIP}/Connector/rest`
          : protocol == 'http' ? `http://${masterIP}:8080/Connector/rest` : `https://${masterIP}:8443/Connector/rest`,
          timeout: 20000,
      })
      
      const roomControl = process.env.REACT_APP_ROOM_CONTROL_PATH || "RoomControl";
      roomControlPath = axios.create({
        baseURL: currentIP.startsWith("http")
          ? `${currentIP}/${roomControl}/rest`
          : protocol == 'http' ? `http://${currentIP}:8080/${roomControl}/rest` : `https://${currentIP}:8443/${roomControl}/rest`,
          timeout: 20000,
      })

      activityPath = axios.create({
        baseURL: currentIP.startsWith("http")
          ? `${currentIP}/spaWebApplication/rest`
          : protocol == 'http' ? `http://${currentIP}:8080/spaWebApplication/rest` : `https://${currentIP}:8443/spaWebApplication/rest`,
          timeout: 20000,
      })

      activityPath.interceptors.response.use(
        response => response,
        error => {
          if (error.code === "ECONNABORTED" && error.message.includes("timeout")) {
            error.message = "Request timed out. Please try again later.";
          }
          return Promise.reject(error);
        }
      );

      clientConfigPosBaseEndPoint = axios.create({
        baseURL: (currentIP.startsWith("http") || currentIP.startsWith("https"))
          ? `${currentIP}/posApiApplications/rest`
          : process.env.REACT_APP_API_PROTOCOL == 'http' ? `http://${currentIP}:8080/posApiApplications/rest` : `https://${currentIP}:8443/posApiApplications/rest`
      })

      activityPath = axios.create({
        baseURL: currentIP.startsWith("http")
          ? `${currentIP}/spaWebApplication/rest`
          : protocol == 'http' ? `http://${currentIP}:8080/spaWebApplication/rest` : `https://${currentIP}:8443/spaWebApplication/rest`,
          timeout: 15000,
      })


      if(master_client_config != current_client_config){
        IS_CHILD_CONNECTOR = true;
      } else {
        IS_CHILD_CONNECTOR = false;
      }
}

export const ACTIVITIES_DEMO_DATA_URL = "/../cmsData/activities";



export const ISINROOMTAB = process.env.REACT_APP_IS_INROOM_TAB == "true";
export const DEVICEREGISTRATIONENABLED = process.env.REACT_APP_DEVICE_REGISTRATION_ENABLED == "true";

export const SOFT_PHONE_ENABLED = process.env.REACT_APP_SOFT_PHONE_ENABLED == "true";
export const LANDSCAPE_ENABLED = process.env.REACT_APP_LANDSCAPE_ENABLED == "true";

export const DEMO_FLOW_ENABLED = process.env.REACT_APP_DEMO_FLOW_ENABLED == "true";
export const CHECKIN_DEMO_FLOW = process.env.REACT_APP_CHECKIN_DEMO_FLOW == "true";

export const APP_TYPE = process.env.REACT_APP_IS_BETA_APP == "true" ? "Beta" : "Prod";

export const INITIAL_LOADER_SCREEN = process.env.REACT_APP_INITIAL_LOADER_SCREEN;

export const locationSelectorWidget = [
    "location",
    "locations"
]

export const PRE_CHECKIN = "Pre Check-in"
export const EARLY_CHECKIN = "Early Check-in"
export const MOBILE_CHECKIN = "Mobile Check-in"


export const myStayTab = ["mystay", "mystays"];

export const chatKeys = [
  "chat",
  "chats",
  "messages",
  "messaging",
]

export const ALLIANTS_CHAT = "alliants";
export const INNSPIRECHAT = "innspirechat";

export const doorKey = [
  "doorkey",
  "doorkeys",
]

export const tabphone = [
  "phone",
  'call',
  'dial-pad',
  'dialpad'
]

export const notificationKey = [
  "notification",
  "notifications"
]

export const checkOutKey = [
  "check-out",
  "mybill",
  "checkout",
  "billcheckout"
]

export const appLogo = [
  "logo",
  "hotellogo",
  "applogo"
]



export const ASSAABLOY = 'assaabloy';
export const DORMAKABA = 'dormakaba';
export const SALTO = 'salto';

export const DOOR_KEY_TYPES = {
  assaabloy: ["ASSAABLOY", "AssaAbloy", "assaabloy", "AA", "aa"],
  dormakaba: ["DORMAKABA", "Dormakaba", "dormakaba", "DK", "dk"],
  salto: ["SALTO", "Salto", "salto"],
};
